import React, { useEffect } from 'react';
import { Form, Select } from 'antd';
import ProForm from '@ant-design/pro-form';
import { contactChoiceOptions, useContactChoices } from '@/components/Contacts/useContactChoices';
import { F } from '@/utils/intl';

/** The booking form field the contact goes into. */
export const APPOINTMENT_CONTACT_FIELD = 'contact_id';

/**
 * Who the appointment is with, among the project's contacts — the project's
 * primary unless picked otherwise; they get the appointment's emails. Hidden
 * when there is nobody else to pick (the backend then takes the primary).
 */
const AppointmentContactField: React.FC<{ leadId: string }> = ({ leadId }) => {
  const form = Form.useFormInstance();
  const { contacts, defaultId } = useContactChoices({ leadId });

  // Another project: its own default, never the last project's pick.
  useEffect(() => {
    form.setFieldValue(APPOINTMENT_CONTACT_FIELD, defaultId);
  }, [form, defaultId]);

  if (!contacts || contacts.length < 2) return null;
  return (
    <ProForm.Item
      name={APPOINTMENT_CONTACT_FIELD}
      label={<F id="entity.contact.singular" defaultMessage="Contact" />}
      extra={<F id="component.contacts.appointmentContactHint" defaultMessage="Gets the appointment emails." />}
    >
      <Select size="large" options={contactChoiceOptions(contacts)} data-testid="appointment-contact-select" />
    </ProForm.Item>
  );
};

export default React.memo(AppointmentContactField);
